import { GroupPluginsList } from "./GroupPluginsList";

export default GroupPluginsList;
